export const processSite = () => {
  return 'template-ecommerce-shop.appbaystudio.com'
}